import { render, staticRenderFns } from "./DiffStoragePower.vue?vue&type=template&id=35654586&scoped=true&"
import script from "./DiffStoragePower.vue?vue&type=script&lang=js&"
export * from "./DiffStoragePower.vue?vue&type=script&lang=js&"
import style0 from "./DiffStoragePower.vue?vue&type=style&index=0&id=35654586&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35654586",
  null
  
)

export default component.exports